import React from 'react';
import { pathname } from '../../../../utils/path/path';
import { useQuery } from '../../../../hooks/useQuery';
import { useGetPlatformQuestions } from './questions';
import { getOtherQuestions } from './other-questions';
import Content from '../../../../components/Onboarding/GetStarted/Platform';

export default function Platform() {
  const urlParams = useQuery();
  const questions = useGetPlatformQuestions(urlParams);
  const otherQuestions = getOtherQuestions();

  return (
    <Content
      progressBarPath={pathname.preLogin.getStarted}
      exit={true}
      continuePath={pathname.preLogin.getStarted.salesRevenue.url}
      firstPage={true}
      questions={questions}
      otherQuestions={otherQuestions}
    />
  );
}
